import React, { useEffect, useRef, useState } from 'react';
import styles from './RayvoOne.module.css';
import { showToast } from '../../../../utils/toast';
import PrimaryButton from '../../../../components/Buttons/PrimaryButton/PrimaryButton';

const Features = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target); 
        }
      },
      {
        threshold: 0.1, 
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const handlePreorderClick = (e) => {
    e.preventDefault();
    showToast.comingSoon();
  };

  return (
    <section id="Features" className={styles.visionOneFeatures} ref={sectionRef}>
      <div className={`${styles.wLayoutBlockcontainer} ${styles.container5} ${styles.wContainer}`}>
        <div className={styles.divBlock18}>
          <div className={`${styles.divBlock19} ${isVisible ? styles.visible : ''}`}>
            <div className={styles.textBlock18}>LAUNCHING 2025</div>
            <h1 className={styles.heading8}>Rayvo One, Elevate Every Moment</h1>
            <div className={`${styles.textBlock15} ${isVisible ? styles.visibleText : ''}`}>
              Experience cutting-edge technology with Rayvo One. From voice calls to real-time translation and daily rewards, redefine what smart living means with a single pair of glasses.
            </div>
          </div>
        </div>

        <div className={`${styles.features} ${isVisible ? styles.visible : ''}`}>
          <div className={styles.divBlock17}>
            <img src="images/Feature-Icons-VC.svg" loading="lazy" alt="" className={styles.image4} />
            <div className={styles.textBlock8}><strong className={styles.boldText}>Voice Calls</strong></div>
            <div className={styles.textBlock9}>Seamlessly make and receive phone calls with just a tap on your smart glasses.</div>
          </div>

          <div className={styles.divBlock17}>
            <img src="images/Feature-Icons-Trans.svg" loading="lazy" alt="" className={styles.image4} />
            <div className={styles.textBlock8}><strong className={styles.boldText2}>Real-time Translation</strong></div>
            <div className={styles.textBlock9}>Instantly translate languages while communicating with others.</div>
          </div>

          <div className={styles.divBlock17}>
            <img src="images/Feature-Icons-MUSIC.svg" loading="lazy" alt="" className={styles.image4} />
            <div className={styles.textBlock8}><strong className={styles.boldText3}>Music Streaming</strong></div>
            <div className={styles.textBlock9}>Enjoy high-quality music on the go, integrated directly into your eyewear.</div>
          </div>

          <div className={styles.divBlock17}>
            <img src="images/Feature-Icons.svg" loading="lazy" alt="" className={styles.image4} />
            <div className={styles.textBlock8}><strong>Navagation</strong></div>
            <div className={styles.textBlock9}>Get real-time directions and navigate hands-free through built-in GPS.</div>
          </div>

          <div className={styles.divBlock17}>
            <img src="images/Feature-Icons-PS.svg" loading="lazy" alt="" className={styles.image4} />
            <div className={styles.textBlock8}><strong className={styles.boldText4}>Personal Assistant</strong></div>
            <div className={styles.textBlock9}>A smart assistant tailored to your needs, helping with reminders, tasks, and more.</div>
          </div>

          <div className={styles.divBlock17}>
            <img src="images/Feature-Icons-EARN.svg" loading="lazy" alt="" className={styles.image4} />
            <div className={styles.textBlock8}><strong className={styles.boldText4}>Daily Wear Rewards</strong></div>
            <div className={styles.textBlock9}>Earn tokens daily simply by wearing your DeGlass smart glasses.</div>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <PrimaryButton 
            onClick={handlePreorderClick}
            className={styles.darkButton}
          >
            Preorder
          </PrimaryButton>
        </div>
      </div>
    </section>
  );
};

export default Features;